module.exports = __webpack_public_path__ + "img/logo-fullcolor.33b17307.png";